/**
 * Copyright 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { v4 } from "uuid";
import { Text } from "@nordcloud/gnui";
import { isNotEmpty } from "~/tools";
import { formatPlanCronDescription } from "~/views/plans/utils";
import { NextDateTooltip } from "../components/NextDateTooltip";

type Props = {
  cronExpression?: string;
  nextExecutionDates: string[];
  scheduleOffset: number;
};

export function NextCronDatesTooltip({
  nextExecutionDates,
  cronExpression,
  scheduleOffset,
}: Props) {
  return (
    <NextDateTooltip
      tooltip={
        isNotEmpty(nextExecutionDates)
          ? nextExecutionDates.map((date) => (
              <Text key={v4()} size="sm" mb={0} color="text01">
                Next: {date}
              </Text>
            ))
          : null
      }
      description={formatPlanCronDescription(cronExpression, scheduleOffset)}
    />
  );
}
